import DownloadPointsBox from './DownloadPointsBox'

export default DownloadPointsBox
